module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/inactive/soccer-2efb4c3849d2124060d82b43a2bc2e0e.svg";